export enum PollTag {
  Other = '1',
  Equality = '2',
  AnimalWelfare = '3',
  Audit = '4',
  DefenceSecurity = '5',
  Environment = '6',
  HumanRights = '7',
  Lobbying = '8',
  Management = '9',
}

type PollTagKey = keyof typeof PollTag

export const PollTagMap = new Map<PollTag, PollTagKey>([
  [PollTag.Other, 'Other'],
  [PollTag.Equality, 'Equality'],
  [PollTag.AnimalWelfare, 'AnimalWelfare'],
  [PollTag.Audit, 'Audit'],
  [PollTag.DefenceSecurity, 'DefenceSecurity'],
  [PollTag.Environment, 'Environment'],
  [PollTag.HumanRights, 'HumanRights'],
  [PollTag.Lobbying, 'Lobbying'],
  [PollTag.Management, 'Management'],
])
